import {
  Button,
  Text,
  Loader,
  PasswordInput,
  Stack,
  Center,
  Box,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import { displayErrorMessage } from "../shared/ErrorMessage";
import { initialize, updateField } from "../slices/form/loginWithPassword";
import { useEffect } from "react";
import { useAuth } from "../authentication/AuthProvider";
import { useLocation } from "wouter";
import { Logo } from "../shared/components/Logo";

interface Props {
  email: string;
}
const LoginWithPassword = (props: Props) => {
  const { data } = useAppSelector(
    (state: RootState) => state.loginWithPasswordForm
  );
  const { signIn, loading } = useAuth();
  const [_, navigate] = useLocation();

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initialize({ password: "" }));
  }, []);

  const handleClickEmailPassword = async () => {
    if (data === undefined) {
      console.error("Data is undefined but should not be");
      return;
    }

    try {
      if (data.password == null) {
        displayErrorMessage("Password is required.");
        return;
      }
      await signIn(props.email, data.password);
    } catch (error) {
      displayErrorMessage("Login failed.");
      return;
    }
    const nextPage = localStorage.getItem("intendedUrl");
    localStorage.removeItem("intendedUrl");
    navigate(nextPage ?? "/");
  };

  if (loading || !data) {
    return <Loader color="blue" />;
  }

  return (
    <Center style={{ height: "100vh" }}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleClickEmailPassword();
        }}
      >
        <Stack align="center" justify="center" gap="sm">
          <Box w={100}>
            <Logo />
          </Box>
          <Text size="lg">
            Login to Early Bird RSVP with your password. You must have
            registered <strong>{props.email}</strong> previously.
          </Text>
          <PasswordInput
            mt="sm"
            label="Password"
            style={{ width: "300px" }}
            value={data.password ?? ""}
            onChange={(v) => {
              dispatch(
                updateField({
                  field: "password",
                  value: v.currentTarget.value,
                })
              );
            }}
          />
          <Button
            style={{ width: "250px" }}
            onClick={handleClickEmailPassword}
            disabled={data.password == ""}
          >
            Login with password
          </Button>
          <span style={{ width: "300px" }}>
            Forgot password? Go back to the login page and login with an email
            link.
          </span>
        </Stack>
      </form>
    </Center>
  );
};

export default LoginWithPassword;
